@if (store.selectedTable && store.columns.length) {
  <p class="import-blank-values__intro">{{ 'TRANS__IMPORT__BLANK_VALUES__INTRO' | translate }}</p>

  <div class="import-blank-values">
    <div class="import-blank-values__column">

      <section class="import-blank-values__section" aria-labelledby="import-blank-values-suggestions">
        <div class="import-blank-values__heading">
          <mat-icon aria-hidden="true">lightbulb</mat-icon>
          <h4 id="import-blank-values-suggestions">{{ 'TRANS__IMPORT__BLANK_VALUES__SUGGESTIONS' | translate }}</h4>
          @if (store.columnProfile) {
            <span class="import-blank-values__count">{{ store.blankValueSuggestions.length }}</span>
            <span class="import-blank-values__muted">
              {{ 'TRANS__IMPORT__BLANK_VALUES__SUGGESTIONS_SCOPE' | translate: {rows: store.columnProfile.rowsScanned} }}
            </span>
          }
        </div>
        <mat-card appearance="outlined">
          <mat-card-content>
            @if (store.columnProfileLoading) {
              <div class="import-blank-values__state">
                <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
                <span>{{ 'TRANS__IMPORT__BLANK_VALUES__SUGGESTIONS_LOADING' | translate }}</span>
              </div>
            } @else if (store.columnProfileFailed) {
              <div class="import-blank-values__state">
                <span class="import-blank-values__error">
                  {{ 'TRANS__IMPORT__BLANK_VALUES__SUGGESTIONS_FAILED' | translate }}
                </span>
                <button mat-stroked-button type="button" color="primary" (click)="store.loadColumnProfile()">
                  <span class="bold uppercase">{{ 'TRANS__IMPORT__BLANK_VALUES__RETRY' | translate }}</span>
                </button>
              </div>
            } @else {
              @for (suggestion of store.blankValueSuggestions; track suggestionKey(suggestion)) {
                <div class="import-blank-values__suggestion">
                  <div class="import-blank-values__suggestion-text">
                    <div class="import-blank-values__suggestion-head">
                      <span class="import-blank-values__column-name">{{ suggestion.column }}</span>
                      <span class="import-blank-values__value">«{{ suggestion.value }}»</span>
                      <span class="import-blank-values__muted">
                        {{ rowsKey(suggestion.count) | translate: {count: suggestion.count} }}
                      </span>
                      @if (suggestion.term) {
                        <span class="import-blank-values__tag import-blank-values__tag--term">
                          <mat-icon aria-hidden="true">check</mat-icon>
                          {{ 'TRANS__IMPORT__BLANK_VALUES__IN_LIST' | translate: {term: suggestion.term} }}
                        </span>
                      } @else if (suggestion.reason === 'lookup_label_placeholder') {
                        <span class="import-blank-values__tag import-blank-values__tag--lookup">
                          <mat-icon aria-hidden="true">key</mat-icon>
                          {{ 'TRANS__IMPORT__BLANK_VALUES__LOOKUP_GIVES' | translate: {
                            lookup: suggestion.lookupName ?? '', label: suggestion.label ?? ''
                          } }}
                        </span>
                      } @else if (suggestion.reason === 'no_letters_or_digits') {
                        <span class="import-blank-values__muted import-blank-values__reason">
                          {{ 'TRANS__IMPORT__BLANK_VALUES__NO_LETTERS_OR_DIGITS' | translate }}
                        </span>
                      }
                    </div>
                    <p class="import-blank-values__consequence">
                      {{ 'TRANS__IMPORT__BLANK_VALUES__USED_IN' | translate: {usages: usagesText(suggestion.usages)} }}
                      @if (suggestion.term) {
                        {{ 'TRANS__IMPORT__BLANK_VALUES__LIKELY_REAL' | translate }}
                      } @else {
                        @for (phrase of suggestion.consequences; track $index) {
                          {{ phrase.key | translate: phrase.params }}
                        }
                      }
                    </p>
                  </div>
                  <!-- A likely real value makes Ekte verdi the primary action. -->
                  <div class="import-blank-values__actions">
                    <button type="button" color="primary"
                            [matButton]="suggestion.term ? 'outlined' : 'filled'"
                            class="import-blank-values__means-blank"
                            (click)="store.markBlankValue(suggestion.column, suggestion.value)">
                      <span class="bold uppercase">{{ 'TRANS__IMPORT__BLANK_VALUES__MEANS_BLANK' | translate }}</span>
                    </button>
                    <button type="button" color="primary"
                            [matButton]="suggestion.term ? 'filled' : 'outlined'"
                            class="import-blank-values__real-value"
                            (click)="store.rejectBlankValue(suggestion.column, suggestion.value)">
                      <span class="bold uppercase">{{ 'TRANS__IMPORT__BLANK_VALUES__REAL_VALUE' | translate }}</span>
                    </button>
                  </div>
                </div>
              } @empty {
                <p class="import-blank-values__muted import-blank-values__empty">
                  {{ 'TRANS__IMPORT__BLANK_VALUES__SUGGESTIONS_NONE' | translate }}
                </p>
              }
            }
          </mat-card-content>
        </mat-card>
      </section>

      <section class="import-blank-values__section" aria-labelledby="import-blank-values-read-as-blank">
        @let readAsBlank = store.blankValueColumns;
        <div class="import-blank-values__heading">
          <mat-icon aria-hidden="true">block</mat-icon>
          <h4 id="import-blank-values-read-as-blank">{{ 'TRANS__IMPORT__BLANK_VALUES__READ_AS_BLANK' | translate }}</h4>
          <span class="import-blank-values__count">{{ readAsBlank.length }}</span>
        </div>
        <mat-card appearance="outlined">
          <mat-card-content>
            @for (group of readAsBlank; track group.column) {
              <div class="import-blank-values__row">
                <span class="import-blank-values__column-name">{{ group.column }}</span>
                <div class="import-blank-values__chips">
                  <mat-chip-set>
                    @for (value of group.values; track $index) {
                      <mat-chip class="import-blank-values__blank-value" (removed)="store.unmarkBlankValue(group.column, value)">
                        {{ value }}
                        <button matChipRemove type="button"
                                [attr.aria-label]="'TRANS__IMPORT__BLANK_VALUES__REMOVE' | translate: {value: value}">
                          <mat-icon>cancel</mat-icon>
                        </button>
                      </mat-chip>
                    }
                  </mat-chip-set>
                  <button mat-button type="button" color="primary" class="import-blank-values__add-to"
                          (click)="addTo(group.column)">
                    <mat-icon>add</mat-icon>
                    {{ 'TRANS__IMPORT__BLANK_VALUES__VALUE' | translate }}
                  </button>
                </div>
                @if (readAsBlankNote(group); as note) {
                  <span class="import-blank-values__muted import-blank-values__note">
                    @if (note.cells !== null) {
                      {{ cellsKey(note.cells) | translate: {count: note.cells} }}
                    }
                    @if (note.cells !== null && note.usages) {
                      ·
                    }
                    @if (note.usages) {
                      {{ 'TRANS__IMPORT__BLANK_VALUES__NO_VALUE_FROM' | translate: {usages: note.usages} }}
                    }
                  </span>
                }
              </div>
            } @empty {
              <p class="import-blank-values__muted import-blank-values__empty">
                {{ 'TRANS__IMPORT__BLANK_VALUES__READ_AS_BLANK_NONE' | translate }}
              </p>
            }

            <div class="import-blank-values__rejected">
              <span class="import-blank-values__caption">{{ 'TRANS__IMPORT__BLANK_VALUES__REJECTED' | translate }}</span>
              @for (group of rejectedColumns; track group.column) {
                <div class="import-blank-values__row">
                  <span class="import-blank-values__column-name">{{ group.column }}</span>
                  <mat-chip-set>
                    @for (value of group.values; track $index) {
                      <mat-chip class="import-blank-values__rejected-value"
                                (removed)="store.unrejectBlankValue(group.column, value)">
                        {{ value }}
                        <button matChipRemove type="button"
                                [attr.aria-label]="'TRANS__IMPORT__BLANK_VALUES__UNDO' | translate: {value: value}">
                          <mat-icon>undo</mat-icon>
                        </button>
                      </mat-chip>
                    }
                  </mat-chip-set>
                </div>
              } @empty {
                <span class="import-blank-values__muted">
                  {{ 'TRANS__IMPORT__BLANK_VALUES__REJECTED_NONE' | translate }}
                </span>
              }
            </div>
          </mat-card-content>
        </mat-card>
      </section>
    </div>

    <aside class="import-blank-values__column">
      <section class="import-blank-values__section" aria-labelledby="import-blank-values-add">
        <h4 id="import-blank-values-add">{{ 'TRANS__IMPORT__BLANK_VALUES__ADD_OWN' | translate }}</h4>
        <mat-card appearance="outlined">
          <mat-card-content>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ 'TRANS__IMPORT__BLANK_VALUES__COLUMN' | translate }}</mat-label>
              <mat-select [formControl]="columnControl" class="import-blank-values__add-column">
                @for (column of store.columns; track column.name) {
                  <mat-option [value]="column.name">{{ column.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ 'TRANS__IMPORT__BLANK_VALUES__VALUE' | translate }}</mat-label>
              <input #valueInput matInput class="import-blank-values__add-value" [formControl]="valueControl"
                     [placeholder]="'TRANS__IMPORT__BLANK_VALUES__VALUE_PLACEHOLDER' | translate"
                     (keydown.enter)="add()">
            </mat-form-field>
            @if (topValues.length) {
              <div class="import-blank-values__top">
                <span class="import-blank-values__caption">
                  {{ 'TRANS__IMPORT__BLANK_VALUES__TOP_VALUES' | translate: {column: columnControl.value} }}
                </span>
                @for (top of topValues; track top.value) {
                  <button mat-button type="button" class="import-blank-values__top-value"
                          (click)="valueControl.setValue(top.value)">
                    <span class="import-blank-values__top-text">{{ top.value }}</span>
                    <span class="import-blank-values__muted">{{ top.count }}</span>
                  </button>
                }
              </div>
            }
            <div>
              <button mat-stroked-button type="button" color="primary" class="import-blank-values__add"
                      [disabled]="!canAdd" (click)="add()">
                <mat-icon>add</mat-icon>
                <span class="bold uppercase">{{ 'TRANS__IMPORT__BLANK_VALUES__ADD' | translate }}</span>
              </button>
            </div>
          </mat-card-content>
        </mat-card>
      </section>

      <section class="import-blank-values__section" aria-labelledby="import-blank-values-how">
        <div class="import-blank-values__heading">
          <mat-icon aria-hidden="true">info</mat-icon>
          <h4 id="import-blank-values-how">{{ 'TRANS__IMPORT__BLANK_VALUES__HOW_TITLE' | translate }}</h4>
        </div>
        <mat-card appearance="outlined">
          <mat-card-content>
            <ul class="import-blank-values__how">
              <li>{{ 'TRANS__IMPORT__BLANK_VALUES__HOW_PLACEHOLDERS' | translate }}</li>
              <li>{{ 'TRANS__IMPORT__BLANK_VALUES__HOW_NO_LETTERS' | translate }}</li>
              <li>{{ 'TRANS__IMPORT__BLANK_VALUES__HOW_LOOKUP' | translate }}</li>
            </ul>
            <p class="import-blank-values__muted import-blank-values__empty">
              {{ 'TRANS__IMPORT__BLANK_VALUES__HOW_LIKELY_REAL' | translate }}
            </p>
          </mat-card-content>
        </mat-card>
      </section>
    </aside>
  </div>
}
